import { createContext } from "react";
import SpeechNode from "../nodes/dialogue/SpeechNode";

export default createContext([new SpeechNode('previousDialogueTest', null, 'someone said this before, I think they must be going insane...')]);
